import { IconButton } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { CloseIcon } from 'src/components/icons';
import { DividersAndCardBorders } from 'src/theme/colors';
import { RegularCardShadow } from 'src/theme/shadows';

const useStyles = makeStyles<{ shouldHideBorder: boolean }>()(
  (theme, { shouldHideBorder }) => ({
    root: {
      boxShadow: RegularCardShadow,
      position: 'relative', // needed to position child elements that have absolute position,
      border: shouldHideBorder ? 'none' : `1px solid ${DividersAndCardBorders}`,
      borderRadius: theme.shape.borderRadius,
      '&:hover': {
        // show dismiss card button when card is hovered
        '& .dismissBtn': {
          display: 'block',
          [theme.breakpoints.down('xs')]: {
            display: 'none',
          },
        },
      },
    },

    dismissButton: {
      display: 'none',
      position: 'absolute',
      top: theme.spacing(1),
      right: theme.spacing(1),
      height: 20,
      width: 20,
    },
  }),
);

interface Props {
  children: React.ReactNode;
  className?: string;
  shouldHideBorder?: boolean;
  onDismissClick?: () => void;
  onClick?: () => void;
}

export const RegularCardBox: React.FC<Props> = (props) => {
  const {
    children,
    className,
    onDismissClick,
    shouldHideBorder = false,
    ...containerDivProps
  } = props;
  const { classes, cx } = useStyles({ shouldHideBorder });

  return (
    <div {...containerDivProps} className={cx(classes.root, className)}>
      {children}

      {onDismissClick && (
        <IconButton
          size="small"
          edge="end"
          onClick={onDismissClick}
          color="secondary"
          className={`${classes.dismissButton} dismissBtn`}
        >
          <CloseIcon style={{ fontSize: 10 }} />
        </IconButton>
      )}
    </div>
  );
};
